import { lazy } from 'react'


const MapRoutes = lazy(() => import('../map/routes'))
const KeplerMap = lazy(() => import('../map/kmap'))
const Layer = lazy(() => import('../layer'))
const Beacons = lazy(() => import('../beacons'))
const SegmentList = lazy(() => import('../segments/segment-list'))
const SegmentCombine = lazy(() => import('../segments/segment-combine'))
const ExportGoogleAdManager = lazy(() => import('../segments/export-google-ad-manager'))
const ListGoogleAdManager = lazy(() => import('../segments/list-google-ad-manager'))
const Segment = lazy(() => import('../segment'))
const SegmentShare = lazy(() => import('../segment/share-index'))
const POI = lazy(() => import('../poi'))
const LoyaltyRoutes = lazy(() => import('../loyalty-index/routes'))
const Marketplace = lazy(() => import('../new-marketplace'))
const Requests = lazy(() => import('../requests'))
const Finance = lazy(() => import('../finance'))
const ConnectionHub = lazy(() => import('../connection-hub'))
const ML = lazy(() => import('../ml'))
const GPTTargeting = lazy(() => import('../gpt-targeting'))
const DOOHMap = lazy(() => import('../ooh-map'))
const Home = lazy(() => import('../home'))
const Notebook = lazy(() => import('../notebook'))
const WidgetStudio = lazy(() => import('../widget-studio'))
const Dashboard = lazy(() => import('../dashboard'))

export const routes = [
  {
    section: 'home',
    route: 'home',
    content: 'Home',
    Component: Home,
    base: true,
  },
  {
    section: 'map',
    route: 'map',
    content: 'Map',
    Component: MapRoutes,
    base: true,
  },
  {
    section: 'map',
    route: 'kmap/:mapID',
    Component: KeplerMap,
    base: true,
    hideNav: true,
  },
  {
    section: 'layer',
    route: 'layer',
    content: 'Layer',
    Component: Layer,
    base: true,
  },
  {
    section: 'beacons',
    route: 'beacons',
    content: 'Beacons',
    Component: Beacons,
    base: true,
  },
  {
    section: 'poi',
    route: 'poi',
    content: 'POI',
    Component: POI,
    base: true,
    exact: true,
  },
  {
    section: 'poi',
    route: 'poi/:poiListID(\\d+)',
    Component: POI,
    base: true,
    hideNav: true,
  },
  {
    section: 'segments',
    route: 'segments',
    content: 'Segments',
    Component: SegmentList,
    base: true,
  },
  {
    section: 'segments',
    route: 'segments-gam',
    Component: ExportGoogleAdManager,
    base: true,
    hideNav: true,
  },
  {
    section: 'segments',
    route: 'segments-gam-list',
    Component: ListGoogleAdManager,
    base: true,
    hideNav: true,
  },
  {
    section: 'segments',
    route: 'segments-combine/:id?',
    Component: SegmentCombine,
    base: true,
    hideNav: true,
  },
  {
    section: 'segments',
    route: 'segment/:id',
    Component: Segment,
    base: true,
    hideNav: true,
  },
  {
    section: 'segments',
    route: 'segment-share/:id(\\d+)',
    Component: SegmentShare,
    base: true,
    hideNav: true,
  },
  {
    section: 'builder',
    route: 'builder',
    content: 'Builder',
    Component: Requests,
    base: true,
  },
  {
    section: 'builder',
    route: 'requests',
    to: 'builder',
    base: true,
    hideNav: true,
  },
  {
    section: 'finance',
    route: 'finance',
    content: 'Finance',
    Component: Finance,
    base: false,
  },
  {
    section: 'intelligence',
    route: 'loyalty',
    content: 'Intelligence',
    Component: LoyaltyRoutes,
    base: true,
    beta: true,
  },
  {
    section: 'intelligence',
    route: 'loyalty-index',
    to: 'loyalty',
    base: true,
    hideNav: true,
  },
  {
    section: 'hub',
    route: 'hub',
    content: 'Connection Hub',
    Component: ConnectionHub,
    base: false,
    beta: true,
  },
  {
    section: 'ql',
    route: 'ql',
    content: 'Query Lab',
    Component: ML,
    base: false,
    hideNav: false,
  },
  {
    section: 'ai-targeting',
    route: 'ai-targeting',
    content: 'AI Targeting',
    Component: GPTTargeting,
    base: false,
    hideNav: false,
  },
  {
    section: 'dooh-planner',
    route: 'dooh-planner',
    content: 'DOOH Planner',
    Component: DOOHMap,
    base: false,
    hideNav: false,
  },
  {
    section: 'marketplace',
    route: 'marketplace',
    content: 'Marketplace',
    Component: Marketplace,
    base: true,
    beta: true,
    hideNav: false,
  },
  {
    section: 'marketplace',
    route: 'new-marketplace',
    to: 'marketplace',
    base: true,
    hideNav: true,
  },
  {
    section: 'notebook',
    route: 'notebook',
    content: 'Notebook',
    Component: Notebook,
    base: true,
    beta: true,
  },
  {
    section: 'widget-studio',
    route: 'widget-studio',
    content: 'Widget Studio',
    Component: WidgetStudio,
    base: true,
    beta: true,
  },
  {
    section: 'dashboard',
    route: 'dashboard',
    content: 'Dashboard',
    Component: Dashboard,
    base: false,
    beta: true,
  },
]
